(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-section"] && !window.DesignMode) return;
  try {
    
$('.about-slider').slick({
  dots: false,
  arrows:true,
  infinite: true,
  autoplay:true,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-section"] && !window.DesignMode) return;
  try {
    
$('.new-footer-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    loop: true,
    speed: 5000, // slow transition for continuous effect
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0, // no delay between scrolls
    cssEase: 'linear', // smooth continuous scroll
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            arrows:false,
            infinite: true,
            autoplay:true,
            autoplaySpeed: 2000,
            speed: 500
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
            centerMode:false,
          }
        }
    ]
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"] && !window.DesignMode) return;
  try {
    
  $('.product-slider').slick({
    dots: true,
    arrows:false,
    infinite: false,
    speed: 500,
    autoplay:false,
    autoplaySpeed:2000,
    slidesToShow: 4.5,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4.5,
            slidesToScroll: 1,
            dots: true,
            arrows:false,
            infinite: true,
            speed: 500
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: false,
            initialSlide: 0,
            centerMode:false,
          }
        },
        {
          breakpoint: 575,
          settings: {   
            slidesToShow: 1.5,
            slidesToScroll: 1,
            variableWidth: false,
            initialSlide: 0,
            centerMode:false,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-sale-product"] && !window.DesignMode) return;
  try {
    
    $('.product-slider').slick({
      dots: true,
      arrows:false,
      infinite: true,
      speed: 500,
      autoplay:true,
      autoplaySpeed:2000,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              dots: true,
              arrows:false,
              infinite: true,
              speed: 500
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true,
              initialSlide: 0,
              centerMode:true,
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

$(document).ready(function () {
  $('.dropdown-nav > a').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $parent = $(this).closest('.dropdown-nav');
    var $dropdown = $parent.find('.dropdownwrap');

    // Close all other dropdowns
    $('.dropdown-nav').not($parent).removeClass('active')
      .find('.dropdownwrap').stop(true, true).slideUp(300)
      .find('.animate-blur-wrap').removeClass('animate-blur-clear');

    // Toggle current dropdown
    $parent.toggleClass('active');
    $dropdown.stop(true, true).slideToggle(300, function () {
      if ($dropdown.is(':visible')) {
        const $cols = $dropdown.find('.animate-blur-wrap');
        $cols.removeClass('animate-blur-clear');        // reset class
        void $cols[0].offsetWidth;                      // force reflow
        $cols.addClass('animate-blur-clear');           // apply animation
      }
    });
  });

  // Click outside to close
  $(document).click(function () {
    $('.dropdown-nav').removeClass('active')
      .find('.dropdownwrap').stop(true, true).slideUp(300)
      .find('.animate-blur-wrap').removeClass('animate-blur-clear');
  });

  $('.dropdown-nav').click(function (e) {
    e.stopPropagation();
  });
});


  
// Header Script Start
$('.menu-Bar').click(function() {
    // $(this).toggleClass('open');
    $('.menuWrap').toggleClass('open');
    $('html').toggleClass('ovr-hiddn');
    $('body').toggleClass('ovr-hiddn');
    $(".menuBox").removeClass("current");
    $(".menuBox span").find("img").removeClass("rotate-img")
    $(".menuContent").removeClass("open");
    $(".submobiledrop-subcategory-head").removeClass("current")
    $(".image-slider-wrapper").removeClass("open")
});
$('.searchslide').slick({
  dots: false,
  arrows:false,
  infinite: true,
  vertical:true,
  verticalSwiping: true,
  speed: 500,
  autoplay:true,
  autoplaySpeed:1000,
  slidesToShow: 1,
  slidesToScroll: 1,
});
const searchInput = document.getElementById('searchInput');
const searchSuggestions = document.getElementById('searchSuggestions');
const searchItems = document.querySelectorAll('.search-item');
const searchForm = document.getElementById('searchForm');
searchInput.addEventListener('input', function() {
    if (this.value.length > 0) {
        searchSuggestions.style.display = 'none';
    }
});
searchItems.forEach(item => {
    item.addEventListener('click', function() {
        searchSuggestions.style.display = 'none';
    });
});
var headers = document.getElementsByClassName("dropermenu");
for (var j = 0; j < headers.length; j++) {
  var btns = headers[j].getElementsByClassName("droplist");

  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", function() {
      var isActive = this.classList.contains("active");
      var current = document.getElementsByClassName("active");
      for (var k = 0; k < current.length; k++) {
        current[k].classList.remove("active");
      }
      if (!isActive) {
        this.classList.add("active");
      }
    });
  }
}
$(document).ready(function () {
  const currentPath = window.location.pathname;
  $('.dekstop-menu li a').each(function () {
    const linkPath = $(this).attr('href');

    // Normalize both paths
    // if (linkPath === currentPath || (linkPath !== "/" && currentPath.startsWith(linkPath))) {
    //   $('.dekstop-menu li a').removeClass('active');
    //   $(this).addClass('active');
    //   $(this).closest('li a.first-menu').addClass('active');
    // }

    // Special case: home page
    if (currentPath === '/' && linkPath === '/') {
      // $('.dekstop-menu li a').removeClass('active');
      // $(this).addClass('active');
      $(".dekstop-menu li a.first-menu").addClass('active');
    }
    // else{
    //   $(".dekstop-menu li a.first-menu").removeClass('active');
    // }
  });
  $('[data-target]').on('click', function (e) {
    var target = $(this).data('target');
    var $targetElement = $('.' + target);
    var $drop = $targetElement.closest(".mobiledrop");
    var isAlreadyOpen = $targetElement.hasClass('open');

    // Reset everything
    $(".menuContent").removeClass("open").slideUp(400);
    $(".menuBox").find("img").removeClass("rotate-img");
    $('[data-target]').removeClass('current');

    if (!isAlreadyOpen) {
        $(this).addClass('current');
        $(this).find('img').addClass('rotate-img');

        $targetElement.addClass('open').slideDown(400);
        $('body').addClass('ovr-hiddn');
    } else {
        $targetElement.removeClass('open').slideUp(400);
        $('body').removeClass('ovr-hiddn');
    }
});


  $('[data-targetk]').on('click', function (e) {
	const $clickedItem = $(this);
	const target = $clickedItem.data('targetk');
	const $targetElement = $('.' + target);

	const isAlreadyOpen = $targetElement.hasClass('open');

	// Close all submenus and reset classes
	$(".submobiledrop-subcategory-head").removeClass("current");
	$(".image-slider-wrapper.open").removeClass("open").slideUp(300);
	$('[data-targetk]').removeClass('current');

	if (!isAlreadyOpen) {
		// Open the clicked one with display: flex
		$clickedItem.addClass('current');
		$targetElement.addClass('open').css('display', 'flex').hide().slideDown(300);
		$('body').addClass('ovr-hiddn');
	} else {
		// Close if already open
		$targetElement.removeClass('open').slideUp(300);
		$('body').removeClass('ovr-hiddn');
	}
});



});
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    var windowWidth = $(window).width();

    if (scroll >= 70) {
        $(".main-header").addClass("sticky");
    } else {
        // Only remove sticky class on devices wider than 768px (you can adjust this breakpoint)
        if (windowWidth > 768) {
            $(".main-header").removeClass("sticky");
        }
    }
});
class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
customElements.define('sticky-header', StickyHeader);
// Header Script End


// Product Page Script Start
$(document).ready(function(){
  var currentVariant = $(".swatch-input__label.active").attr("data-varaint-title");
  $(".js.product-form__input .form__label").append('<span class="variant-title">' + currentVariant + '</span>');
  $(".product-form__input label").click(function(){
      console.log("yes clickable!");
      var varId = $(this).attr('data-variant-id');
      var varTitle = $(this).attr('data-varaint-title');
      var varPrice = $(this).attr('data-varaint-price');
      var varComparePrice = $(this).attr('data-varaint-compare-price');
      var varImg = $(this).attr('data-variant-img');
      var varAlt = $(this).attr('data-variant-img-alt');
      var varSlideNum = $(this).attr('data-variant-slider-num');
      $(".js.product-form__input .form__label .variant-title").remove();
      $(".js.product-form__input .form__label").append('<span class="variant-title">' + varTitle + '</span>');
      $(".price-item.price-item--sale.price-item--last").html("");
      $(".price-item.price-item--sale.price-item--last").html(varPrice);
      $(".price-item.price-item--regular").html("");
      $(".price-item.price-item--regular").html(varComparePrice);
      $(".slider-for").slick('slickGoTo', varSlideNum);
      $(".slider-nav").slick('slickGoTo', varSlideNum);
      $(".add-to-cart-form").find(".product-variant-id").val(varId)
  });
})
$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:false,
    // autoplaySpeed: 1000,
    dots: false,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    vertical:true,
    verticalSwiping:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    autoplay:true,
    autoplaySpeed: 3000,
    arrows:false,
    focusOnSelect: true,
     responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          vertical:false,
          verticalSwiping:false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          vertical:false,
          verticalSwiping:false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical:false,
          verticalSwiping:false,
        }
      }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

// Product Page Script End

  
  
// Category Page Script Start
function bindFacetClickEvent() {
  document.querySelectorAll('.facets__summary').forEach(function (summary) {
    summary.addEventListener('click', function () {
      const parentDetails = summary.closest('details');
      const isOpen = parentDetails.hasAttribute('open');

      // Pehle sab band karo
      document.querySelectorAll('details.facets__disclosure[open]').forEach(function (openDetail) {
        if (openDetail !== parentDetails) {
          openDetail.removeAttribute('open');
          openDetail.querySelector('.facets__summary').setAttribute('aria-expanded', 'false');
        }
      });

      // Agar already open nahi tha to isko aria-expanded true karo
      if (!isOpen) {
        summary.setAttribute('aria-expanded', 'true');
      }
    });
  });
}
document.addEventListener('click', function (e) {
  document.querySelectorAll('details.facets__disclosure[open]').forEach(function (openDetail) {
    if (!openDetail.contains(e.target)) {
      openDetail.removeAttribute('open');
      const summary = openDetail.querySelector('.facets__summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    }
  });
});
// Initial bind
bindFacetClickEvent();

// Rebind on DOM update (after filters applied)
document.addEventListener('shopify:section:load', function () {
  bindFacetClickEvent();
});


// Category Page Script End


  
// Home Page Script Start
const observer = new MutationObserver(() => {
  bindFacetClickEvent();
});
observer.observe(document.body, { childList: true, subtree: true });
let itemToShowTwo = 9;
if (window.screen.width < 1600 && window.screen.width >= 1025) {
  itemToShowTwo = 9;
} else if (window.screen.width < 1025 && window.screen.width >= 840) {
  itemToShowTwo = 5;
} else if (window.screen.width < 840 && window.screen.width >= 440) {
  itemToShowTwo = 4;
} else if (window.screen.width < 440) {
  itemToShowTwo = 3;
}
$(".dOnMobCatTwo").slick({
    slidesToShow: itemToShowTwo,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 3,
        }
      }
  ]
  });
$('.brand-parent-box').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    autoplay:true,
    autoplaySpeed: 1000,
    arrows:false,
    focusOnSelect: true,
     responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
  ]
});
// Home Page Script End
if ($(window).width() < 767) {

  $(".main-header").addClass("sticky");
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !window.DesignMode) return;
  try {
    
  // Normal Slider
  // $('.index-slider').slick({
  //   dots: false,
  //   arrows:false,
  //   infinite: true,
  //   fade:false,
  //   autoplay:true,
  //   autoplaySpeed:5000,
  //   speed: 600,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["influencer-products"] && !window.DesignMode) return;
  try {
    
  $('.reels-slider').slick({
    dots: true,
    arrows:false,
    infinite: true,
    autoplay:true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            arrows:false,
            infinite: true,
            speed: 500,
            autoplay:true,
            autoplaySpeed:2000,
          }
        },
        {
          breakpoint: 767,
          settings: {
            dots:true,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["launch-video-section"] && !window.DesignMode) return;
  try {
    
$('.reels-sliders').slick({
    dots: true,
    arrows:false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login-support"] && !window.DesignMode) return;
  try {
    
  // Tabbing JS
  $('[data-targetit]').on('click', function(e) {
  $(this).addClass('current');
  $(this).siblings().removeClass('current');
  var target = $(this).data('targetit');
  $('.' + target).siblings('[class^="box-"]').hide();
  $('.' + target).fadeIn();
  $(".tab-slider").slick("setPosition");
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-navigation-strip"]) return;
  try {
    



  $('.mobiel-discover-trigger').on("click",function(){

    $('.mobile-popover-main').addClass("popover-visible"); 
    
  })

  $('.close-mobile-popover').on("click",function(){

    $('.mobile-popover-main').removeClass("popover-visible"); 
    
  })


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reel-section"] && !window.DesignMode) return;
  try {
    
$('.reels-sliders').slick({
    dots: true,
    arrows:false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slide-categories"] && !window.DesignMode) return;
  try {
    
  $('[href="#"]').attr("href", "javascript:;");
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay:true,
    // autoplaySpeed: 2000,
    // fade:true,
    dots: false,
    arrows: false,
    draggable:false,
    asNavFor: '.slider-nav',
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            draggable:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:false
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:false,
            dots: false
          }
        }
      ]
});
$('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
   // autoplay:true,
   //  autoplaySpeed: 2000,
    
    focusOnSelect: true,
    arrows:false,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows:false,
            infinite: true,
            speed: 500
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows:false
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows:false
          }
        }
      ]
});
  
  } catch(e) { console.error(e); }
})();
})();
